export default "__VITE_ASSET__401fe245__"